import React, { useEffect, useState, lazy, Suspense } from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import { useLocation, useHistory } from "react-router-dom";
import { EPATHS } from '../routes/paths.enum';
import ProtectedRoute from '../components/auth/ProtectedRoute';
import RouteSuspenseFallback from '../components/ui/Loading/RouteSuspenseFallback';

import HomePage from './Home/homePage';
import Profile from './MarkePlace/pages/Profile';
import { StyledHeader } from './MarkePlace/Styles';
import { ThemeVars } from '../components/ui/ThemeVars';
import Header from './MarkePlace/menu/header';
import Coupon from './MarkePlace/pages/Coupon/coupon';
import CouponDetail from './MarkePlace/pages/Coupon/couponDetail';
// import UsersList from './MarkePlace/pages/Users/usersList';
// import CreateUser from './MarkePlace/pages/Users/createUser';
// TileDetailsEpic supprimé 2026-05-31 — fusionné dans TileDetails via détection epicMode
// par URL (/land_epic/:landId). Le composant unique gère les 2 routes.
// EditCollectible (page d'édition d'exemplaire dédiée) ARCHIVÉE (§103) — l'édition est désormais
// INLINE sur la fiche standard (ItemDetails, pivot #26). Source conservée dans src/_archive/.
import GetStarted from './MarkePlace/pages/GetStarted/GetStarted';
import { LoadingProvider } from '../components/ui/Loading/LoadingProvider';
import { useDispatch, useSelector } from 'react-redux';
import { selectUser, selectAuthFlags } from '../store/selectors/auth';
import { readStoredUser, removeStoredUser } from '../utils/auth/userStorage';
import ModalRegister from './Modals/modalRegister';
import { fetchAuthorList } from "../store/actions/thunks";
import { login } from "../utils/functions/authenticate";
import * as actions from '../store/actions';
import CodeVerification from './Modals/codeVerification';
// §103 — ResetPassword archivé 2026-07-01 (audit) : page de demande de reset redondante avec
// le modal (ForgotPasswordPanel) ; sa route était déjà commentée. Voir src/_archive/.
import * as AuthService from "../services/AuthService";
import ScrollToTop from './ScrollToTop';
import AdminAction from './MarkePlace/pages/AdminAction';

/* Route-level code-splitting (perf/2026-07-05-route-code-splitting) : chaque composant de
   PAGE est chargé en React.lazy → son code part dans un chunk séparé, téléchargé à la
   navigation (et non plus dans le bundle principal). Zéro changement de logique : seul
   l'`import X` statique devient `const X = lazy(() => import(...))`. Déclarés APRÈS les
   imports (règle import/first). Le <Suspense> autour du <Switch> fournit le fallback. */
const Activity = lazy(() => import('./Activity'));
const Explore = lazy(() => import('./MarkePlace/pages/Explore/'));
const Land = lazy(() => import('./MarkePlace/pages/Land/'));
const MyNFTs = lazy(() => import('./MarkePlace/pages/MyNFTs'));
const Collections = lazy(() => import('./MarkePlace/pages/Collections'));
const CollectionHistory = lazy(() => import('./MarkePlace/pages/Collections/collectionHistory'));
const CollectionDetail = lazy(() => import('./MarkePlace/pages/Collections/collectionDetail'));
const EditItem = lazy(() => import('./MarkePlace/pages/MyNFTs/editItem'));
const Authors = lazy(() => import('./MarkePlace/pages/Authors/authors'));
const Author = lazy(() => import('./MarkePlace/pages/Authors/author'));
const CreateOption = lazy(() => import('./MarkePlace/pages/Wallet/createOptions'));
const CreateMultiple = lazy(() => import('./MarkePlace/pages/Wallet/createMultiple'));
const CryptoExchange = lazy(() => import('./MarkePlace/pages/CryptoExchange'));
const Gain = lazy(() => import('./MarkePlace/pages/Gain/gain'));
const Settings = lazy(() => import('./MarkePlace/pages/Settings/settings'));
const ToastPreview = lazy(() => import('./MarkePlace/pages/ToastPreview'));
const AssetDetails = lazy(() => import('./MarkePlace/pages/Explore/AssetDetails'));
const TileDetails = lazy(() => import('./MarkePlace/pages/Land/TileDetails'));
const TileGroupDetails = lazy(() => import('./MarkePlace/pages/Land/TileGroupDetails'));
const ItemDetails = lazy(() => import('./MarkePlace/pages/Explore/ItemDetails'));
const Transactions = lazy(() => import('./MarkePlace/pages/Transactions'));
const Map = lazy(() => import('./Map'));
const TileMapV2 = lazy(() => import('./TileMapV2'));
const Notifications = lazy(() => import('./MarkePlace/pages/Notifications'));
const PublicProfile = lazy(() => import('./MarkePlace/pages/Profile/PublicProfile'));
const MyBids = lazy(() => import('./MarkePlace/pages/Bids'));
const ConfirmPassword = lazy(() => import('./MarkePlace/pages/confirmPassword'));
const ChangeEmail = lazy(() => import('./MarkePlace/pages/changeEmail'));
const MarketStats = lazy(() => import('./MarkePlace/pages/MarketStats'));
const AdminAnalytics = lazy(() => import('./MarkePlace/pages/AdminAnalytics')); // SPEC-2026-07-03 analytics dashboard
const EpicSSO = lazy(() => import('./MarkePlace/pages/EpicSSO'));
const BuyFromEpic = lazy(() => import('./MarkePlace/pages/BuyFromEpic'));
const CartPage = lazy(() => import('./Cart/CartPage'));
const SupportHome = lazy(() => import('./MarkePlace/pages/Support/SupportHome'));
const SupportPortal = lazy(() => import('./MarkePlace/pages/Support/SupportPortal'));
const SupportBugReport = lazy(() => import('./MarkePlace/pages/Support/SupportBugReport'));
const SupportEarn = lazy(() => import('./MarkePlace/pages/Support/SupportEarn'));
const SupportConsole = lazy(() => import('./MarkePlace/pages/Support/SupportConsole'));
const FeatureRequestsList = lazy(() => import('./MarkePlace/pages/Support/FeatureRequests/index'));
const FeatureRequestNew = lazy(() => import('./MarkePlace/pages/Support/FeatureRequests/FeatureRequestNew'));
const FeatureRequestDetail = lazy(() => import('./MarkePlace/pages/Support/FeatureRequests/FeatureRequestDetail'));
const ApiDocs = lazy(() => import('./ApiDocs'));
const HandoffConsume = lazy(() => import('./MarkePlace/pages/Support/HandoffConsume'));
const SsoRelay = lazy(() => import('./MarkePlace/pages/Support/SsoRelay'));
const PortfolioPage = lazy(() => import('./MarkePlace/pages/Portfolio'));
const WatchlistPage = lazy(() => import('./MarkePlace/pages/Watchlist'));
const AuthorCollectionsPage = lazy(() => import('./MarkePlace/pages/AuthorCollections'));
const AuthorCollectionDetail = lazy(() => import('./MarkePlace/pages/AuthorCollections/detail'));
const UserSubscriptionPage = lazy(() => import('./subscription/UserSubscriptionPage'));
const EarnicoinsPacksPage = lazy(() => import('./earnicoins/EarnicoinsPacksPage'));
/* Cart */
/* Support desk Phase 1 (SPEC-2026-06-10-support-desk.v2) */
/* Feature Requests (SPEC-2026-06-15-feature-requests) */
/* Support desk Phase 1 v3 — badge SSO (SPEC-2026-06-10-support-desk.v3).
   v4 2026-06-25 : la vitrine SupportLanding n'est plus rendue sur le sous-domaine support
   (remplacée par le centre d'aide complet /support / SupportHome). Import retiré. */
/* Subscription mensuel (SPEC-2026-06-14-subscription-monthly.v3) */
/* Earnicoins packs purchase page */
//SWITCH VARIABLE FOR PAGE STYLE
const theme = 'GREY'; //LIGHT, GREY, RETRO

declare global {
  interface Window{
    /* `any` pour rester compatible avec la déclaration globale de wagmi (window.ethereum: any),
       tirée dans le graphe TS par EarniWalletModal — évite TS2717 (conflit de déclarations). */
    ethereum?: any;
  }
}

function Main() {
  const location = useLocation();
  // Flux normal (vague 4 lot 3, remplace le hack nav 2026-06-18) — Main s'abonne au
  // store via useSelector : le user de session est hydraté au boot (store/index.js) et
  // tenu à jour par le module auth (login/logout → session.js écrit _user ET dispatch).
  // selectAuthFlags (mémoïsé) est la SOURCE UNIQUE des 8 flags d'accès ci-dessous — plus
  // aucune lecture directe du storage au render. login/logout re-rendent Main
  // (abonnement store) → les props `allowed={...}` des <ProtectedRoute> reflètent la
  // session courante sans reload. Ce qui, avant, était rustiné par un abonnement à
  // l'accessToken + relecture localStorage (bug : Main non-abonné → nav figée post-login
  // jusqu'à un hard refresh) est désormais structurel.
  //
  // Sémantiques préservées (cf. store/selectors/auth.js) : isAuthenticated = présence
  // accessToken, PAS isVerified (FIX 2026-06-30, SPEC-2026-06-29-auth-confirm-2fa.v1 :
  // navigation libre pour un compte wallet non vérifié, actions gatées serveur) ;
  // isVerified BRUT (undefined pour un visiteur) ; rôles comparés par NOM (EROLES).
  const signedUser = useSelector(selectUser);
  const { isAuthenticated, isAdmin, isCreator, isSupport, isCollaborator, isCollaboratorUE, isSnapshot } =
    useSelector(selectAuthFlags);
  const [showRegisterModal, setShowRegisterModal] = useState(signedUser.isVerified === false);
  const [showResendModal, setShowResendModal] = useState(false);
  // Tick de re-render : sur un switch de wallet (ou une connexion inter-onglets), on force Main à se
  // re-rendre. NB : depuis le lot 3, Main EST abonné au store (selectUser/selectAuthFlags) ;
  // ce tick reste par sécurité pour les cas où seul window.ethereum change sans dispatch
  // (switch de wallet inter-onglets), sans jamais relire localStorage.
  const [, setSwitchTick] = useState(0);
  const dispatch = useDispatch();
  const history = useHistory();
  const formData = new FormData();
  formData.append("metamask", signedUser.metamask);

  useEffect(() => {
    dispatch(fetchAuthorList());
    if (!window.ethereum) return;

    // Fix 2026-06-12 — listener nommé + cleanup
    // A. Sans removeListener, le handler s'accumule à chaque mount → N popups.
    // Fix 2026-06-15 v1 — __earniLoginPending remplace switchPending (regression: reset avant reload).
    //   Drapeau intra-onglet posé pendant la SIWE, désormais levé dans finish() (v5 = plus de reload).
    // Fix 2026-06-15 v3 — RESTAURE la reconnexion auto sur switch (régression v2 : v2 ne faisait que
    //   logout+reload → l'utilisateur n'était plus reconnecté). La race nonce (2 GET /auth/nonce
    //   concurrents → upsert écrase → 400 "invalid SIWE message format") est désormais empêchée par
    //   construction via un MUTEX à deux drapeaux mutuellement exclusifs :
    //     • __earniLoginPending      = ce handler global fait un switch+SIWE
    //     • __earniWalletConnecting  = EarniWalletModal fait un connect+SIWE
    //   Chaque initiateur SIWE refuse de démarrer si l'autre drapeau est posé (voir useWalletConnect.js).
    //   Au plus UN flux SIWE actif à la fois ⇒ au plus UN GET /auth/nonce par wallet ⇒ aucune race possible.

    // Fix 2026-06-15 v4 — SINGLE-FLIGHT INTER-ONGLETS (spec multi-onglets Jonathan).
    //   Cause prouvée par diagnostic (_src/_pl/_n) : avec N onglets ouverts, CHAQUE onglet écoute
    //   accountsChanged et lance SA propre SIWE → N signatures + N GET /auth/nonce qui s'écrasent
    //   côté serveur (LoginNonces.wallet = PRIMARY KEY) → 400 → pas reconnecté.
    //   Solution : un seul onglet "leader" (élu via Web Locks) exécute la SIWE → 1 SEULE signature
    //   quel que soit le nombre d'onglets. Les autres onglets ne signent pas et se connectent via
    //   l'event `storage` (le leader écrit `_user`). L'onglet VISIBLE est prioritaire pour le verrou.

    const runSiweLeader = (currentAccount: string | null): Promise<unknown> => {
      (window as any).__earniLoginPending = true; // verrou intra-onglet, levé dans finish()
      // VITESSE v5 (2026-06-15) : PLUS DE RELOAD de l'onglet leader. login() lit eth_accounts (= nouveau
      // compte) → nonce → personal_sign → verify → setUser + localStorage. À la fin (succès OU échec) on
      // lève le verrou intra-onglet ET on force un re-render de Main → les flags/routes se recalculent
      // depuis localStorage (déjà à jour) pour le nouveau compte. Le header se met à jour via son useSelector.
      const finish = () => {
        (window as any).__earniLoginPending = false;
        setSwitchTick((t) => t + 1);
      };
      const doLogin = () => login(dispatch, actions.setLoading, actions.setUser, history).finally(finish);
      if (currentAccount) {
        // VITESSE : NE PAS attendre signout() (round-trip réseau) avant de demander la signature.
        // On invalide l'ancienne session localement + en fire-and-forget, puis on enchaîne la SIWE.
        // login() réécrira `_user` de toute façon ; l'ancien token serveur expirera seul (6 h).
        try {
          removeStoredUser();
          localStorage.removeItem('_first');
          localStorage.removeItem('_authTs');
        } catch (e) { /* storage indisponible : ignore */ }
        dispatch((actions.setUser as any)({})); // état visiteur immédiat pendant la signature
        AuthService.signout().catch(() => { /* fire-and-forget : pas de blocage sur le réseau */ });
        return doLogin();
      }
      return doLogin();
    };

    const handleAccountsChanged = (accounts: string[]) => {
      const newAccount = (accounts && accounts[0]) ? accounts[0].toLowerCase() : null;
      const storedUser = readStoredUser();
      const currentAccount = storedUser?.metamask ? storedUser.metamask.toLowerCase() : null;

      if (!newAccount) return;                              // déconnexion wallet : on ignore
      if (newAccount === currentAccount) return;            // même compte : event informationnel
      if ((window as any).__earniLoginPending) return;      // un switch est déjà en cours (cet onglet)
      if ((window as any).__earniWalletConnecting) return;  // mutex : EarniWalletModal gère ce connect

      const locks = (navigator as any)?.locks;
      if (locks && typeof locks.request === 'function') {
        // Élection du leader : ifAvailable → le 1er onglet obtient le verrou, les autres reçoivent
        // null immédiatement (ils ne signent pas). Le verrou est TENU jusqu'au reload (promesse jamais
        // résolue) → aucun autre onglet ne peut signer pendant toute la durée de la signature.
        const acquire = () => locks.request(
          'earni-siwe-switch',
          { ifAvailable: true },
          (lock: unknown) => {
            if (!lock) return undefined;                    // un autre onglet est leader → on attend le storage event
            // Le verrou est tenu pendant TOUTE la SIWE (signature + verify) puis libéré quand login()
            // se termine → aucun autre onglet ne peut signer pendant ce temps ; après succès, les autres
            // onglets se connectent via le storage event (donc plus besoin de signer non plus).
            return runSiweLeader(currentAccount);
          }
        ).catch(() => { /* lock indisponible/annulé → l'onglet leader gère */ });
        // L'onglet en arrière-plan laisse une fenêtre à l'onglet visible pour devenir leader.
        if (typeof document !== 'undefined' && document.visibilityState !== 'visible') {
          setTimeout(acquire, 250);
        } else {
          acquire();
        }
      } else {
        // Navigateur sans Web Locks → repli mono-onglet (chaque onglet signe).
        runSiweLeader(currentAccount);
      }
    };

    // Connexion inter-onglets : quand le leader (autre onglet) écrit `_user`, l'event storage se
    // déclenche ICI (jamais dans l'onglet écrivain) → on reflète la session dans Redux → cet onglet
    // devient connecté SANS signature. Propage aussi le logout (_user retiré). Au refresh, l'onglet
    // lit directement `_user` de localStorage → connecté de toute façon.
    const handleStorage = (e: StorageEvent) => {
      if (e.key !== '_user') return;
      try {
        const u = JSON.parse(e.newValue || 'null');
        // setUser porte bien le payload au runtime (cf. login()/logout()) ; son type généré est 0-arg → cast.
        dispatch((actions.setUser as any)(u && u.accessToken ? u : {}));
      } catch { /* valeur illisible : ignore */ }
      // Re-render Main → flags/routes du nouveau compte (pas seulement le header) sans reload.
      setSwitchTick((t) => t + 1);
    };

    (window.ethereum as any).on('accountsChanged', handleAccountsChanged);
    window.addEventListener('storage', handleStorage);
    return () => {
      (window.ethereum as any).removeListener('accountsChanged', handleAccountsChanged);
      window.removeEventListener('storage', handleStorage);
    };
  }, [])

  useEffect(() => {
    if(location.pathname===EPATHS.HOME) {
      setShowRegisterModal(signedUser.isVerified === false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname])

  useEffect(() => {
    setShowRegisterModal(signedUser.isVerified === false);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [signedUser.isVerified]);

  // Assistant chat widget (earni-assistant) — monté UNE seule fois globalement sur la
  // marketplace (pas par page). Le script injecte un bouton flottant #eacb-btn que la home
  // support (et tout futur déclencheur) ouvre via document.getElementById('eacb-btn').click().
  // CORS marketplace géré côté orchestrateur (assistant). Pas sur le sous-domaine support
  // (vitrine autonome SupportLanding, rendue avant ce point).
  useEffect(() => {
    const WIDGET_ID = 'earni-assistant-widget';
    if (document.getElementById(WIDGET_ID)) return;
    const script = document.createElement('script');
    script.id = WIDGET_ID;
    script.src = 'https://earniverse.io/assistant/widget/assistant-widget.js';
    script.defer = true;
    script.setAttribute('data-api', 'https://earniverse.io/assistant');
    script.setAttribute('data-site', 'marketplace');
    document.body.appendChild(script);
  }, []);

  // Bulle de chat (earni-assistant) masquée sur les pages plein-panneau (tile-map) où le
  // bouton flottant #eacb-btn et son panneau chevauchent la fiche terrain (ParcelDetails).
  // Règle CSS gated par un attribut body (robuste au chargement async du script), togglée
  // selon la route — le widget reste monté UNE fois globalement (§100), seulement masqué ici.
  useEffect(() => {
    const STYLE_ID = 'earni-assistant-hide-css';
    if (!document.getElementById(STYLE_ID)) {
      const style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent = 'body[data-hide-assistant="1"] [id^="eacb"]:not(#eacb-css){display:none !important;}';
      document.head.appendChild(style);
    }
    const HIDE_ON: string[] = [EPATHS.TILE_MAP, EPATHS.TILE_MAP_V2];
    if (HIDE_ON.includes(location.pathname)) {
      document.body.setAttribute('data-hide-assistant', '1');
    } else {
      document.body.removeAttribute('data-hide-assistant');
    }
  }, [location.pathname]);

  // (SPEC v2 A) — le harnais de preview UIX n'est plus monté ici : il a son propre entry
  // léger (src/index.preview.tsx, swap craco UIX_PREVIEW=1). Plus de gate REACT_APP_UIX_PREVIEW
  // dans le routeur app → un seul chemin de preview, zéro code preview dans le bundle prod.

  // Support v4 (décision Jonathan 2026-06-25, remplace SPEC-2026-06-10-support-desk.v3 §5) :
  // le sous-domaine support affiche désormais le centre d'aide complet /support (SupportHome)
  // dans le shell marketplace, URL conservée — plus la vitrine fine SupportLanding.
  // La redirection HOME → /support sur hôte support est posée dans le <Switch> ci-dessous.
  // Le bloqueur mobile (public/index.html < 950px) exempte ce hostname (inchangé).
  // Regex couvre : support.earniverse.io, support2.earniverse.io, support-dev.earniverse.io.
  const isSupportHost =
    typeof window !== 'undefined' && /^support(2|-dev)?\./.test(window.location.hostname);

  // Routes du domaine support — définies UNE fois (§9 DRY), consommées par le Switch marketplace
  // ET le Switch support-only (isSupportHost). Ordre préservé : routes agent AVANT routes user
  // (évite que /support/agent matche /support/:id) ; features AVANT SUPPORT_DETAIL paramétrique.
  // /auth/handoff + /sso/relay (pont SSO « badge ») : aucun chevauchement de path → ordre libre.
  const supportRoutes = [
    <ProtectedRoute key="sup-agent" exact path={EPATHS.SUPPORT_AGENT} component={SupportConsole} allowed={isAuthenticated && isSupport} />,
    <ProtectedRoute key="sup-agent-detail" exact path={EPATHS.SUPPORT_AGENT_DETAIL} component={SupportConsole} allowed={isAuthenticated && isSupport} />,
    <ProtectedRoute key="sup-home" exact path={EPATHS.SUPPORT} component={SupportHome} allowed={true} />,
    <ProtectedRoute key="sup-portal" exact path={EPATHS.SUPPORT_PORTAL} component={SupportPortal} allowed={isAuthenticated} />,
    <ProtectedRoute key="sup-bug" exact path={EPATHS.SUPPORT_BUG_REPORT} component={SupportBugReport} allowed={isAuthenticated} />,
    <Route key="sup-earn" exact path={EPATHS.SUPPORT_EARN} component={SupportEarn} />,
    <ProtectedRoute key="sup-feat" exact path={EPATHS.SUPPORT_FEATURES} component={FeatureRequestsList} allowed={isAuthenticated} />,
    <ProtectedRoute key="sup-feat-new" exact path={EPATHS.SUPPORT_FEATURES_NEW} component={FeatureRequestNew} allowed={isAuthenticated} />,
    <ProtectedRoute key="sup-feat-detail" exact path={EPATHS.SUPPORT_FEATURES_DETAIL} component={FeatureRequestDetail} allowed={isAuthenticated} />,
    <ProtectedRoute key="sup-detail" exact path={EPATHS.SUPPORT_DETAIL} component={SupportPortal} allowed={isAuthenticated} />,
    <Route key="sup-handoff" exact path={EPATHS.AUTH_HANDOFF} component={HandoffConsume} />,
    <Route key="sup-sso-relay" exact path={EPATHS.SSO_RELAY} component={SsoRelay} />,
  ];

  return (
    <LoadingProvider>
    {/* Dark mode : feuille de variables CSS (point unique light/dark). Le thème réel est posé
        sur html[data-theme] par l'effet du Header (applicateur unique) + le pré-apply anti-FOUC (index.tsx). */}
    <ThemeVars />
    <div>
      <StyledHeader theme={theme} />
  {/* {(
    location.pathname!==EPATHS.HOME &&
    location.pathname!==EPATHS.EXPLORE &&
    location.pathname!==EPATHS.AUTHORS &&
    location.pathname!==EPATHS.MY_COLLECTIONS &&
    location.pathname!==EPATHS.MY_NFTS &&
    location.pathname!==EPATHS.MAPS &&
    location.pathname!==EPATHS.LAND &&
    location.pathname!==EPATHS.TRANSACTIONS &&
    location.pathname!==EPATHS.GAIN &&
    location.pathname!==EPATHS.COUPON &&
    location.pathname!==EPATHS.RESET_PASSWORD &&
    location.pathname!==EPATHS.CONFIRM_PASSWORD &&
    location.pathname!==EPATHS.CHANGE_EMAIL &&
    location.pathname!==EPATHS.MY_COLLECTION_HISTORY &&
    location.pathname!==EPATHS.MY_COLLECTION_DETAIL &&
    location.pathname!==`/3D_Asset/${localStorage.getItem("id")}` ) &&
    <Header className=""/>} */}
    {/* app-route-area : conteneur flex plein écran (min-height:100vh) — garantit que le
        Footer (dernier enfant de la racine de page) reste ferré en bas du viewport visible
        même sur une page à contenu court (sticky footer global, cf. index.css). */}
    <div className="app-route-area">
    <Router>
      <ScrollToTop />
      <Suspense fallback={<RouteSuspenseFallback />}>
      {isSupportHost ? (
        /* Hôte support (support./support2./support-dev.) : SEULES les routes support sont servies.
           Toute URL marketplace tombe sur le catch-all → /support (URL host conservée). Corrige le bug
           où le Switch marketplace complet matchait /tile-map, /land… sur support2 (2026-06-25). */
        <Switch>
          <Route exact path={EPATHS.HOME} render={() => <Redirect to={EPATHS.SUPPORT} />} />
          {supportRoutes}
          <Redirect to={EPATHS.SUPPORT} />
        </Switch>
      ) : (
      <Switch>
        <Route exact path={EPATHS.HOME} component={HomePage} />
        <Route exact path="/toast-preview" component={ToastPreview} />
        <Route exact path={EPATHS.EXPLORE} component={Explore} />
        {/* /activity — globe 3D public d'activité mondiale (TRACK-2026-07-03-activity-globe-3d) */}
        <Route exact path={EPATHS.ACTIVITY} component={Activity} />
        <Route exact path={EPATHS.LAND} component={Land} />
        <Route exact path={EPATHS.ASSET_DETAIL} component={AssetDetails} />
        <Route exact path={EPATHS.LAND_DETAIL} component={TileDetails} />
        <Route exact path={EPATHS.LAND_DETAIL_EPIC} component={TileDetails} />
        <Route exact path={EPATHS.LAND_GROUP_DETAIL} component={TileGroupDetails} />
        {/* Pivot #26 — l'édition d'exemplaire est désormais INLINE sur la fiche standard
            (ItemDetails, editMode). La route dédiée /3D_Collectible/edit/:nftId est retirée
            (0 doublon de route §103) ; les anciens liens y sont redirigés vers la fiche. */}
        <Redirect exact from={EPATHS.EDIT_COLLECTIBLE} to={EPATHS.MY_NFTS} />
        <Route exact path={EPATHS.NFT_DETAIL} component={ItemDetails} />
        {/* Redirection legacy : anciennes URLs /3D_NFT/... → /3D_Collectible/... (bookmarks, notifs/emails déjà envoyés) */}
        <Redirect exact from={EPATHS.NFT_DETAIL_LEGACY} to={EPATHS.NFT_DETAIL} />
        <Route exact path={EPATHS.AUTHORS} component={Authors} />
        <Route exact path={EPATHS.AUTHOR} component={Author} />
        <Route exact path={EPATHS.PROFILE} component={PublicProfile} />
        {/* /wallet — le composant Wallet a été supprimé (Connect Wallet ouvre EarniWalletModal
            directement depuis header.jsx). Bookmarks legacy / liens partagés / recette :
            au lieu de laisser /wallet tomber dans le catch-all Redirect→HOME (page d'accueil
            marketing, confus pour un user connecté), on redirige explicitement vers /setting
            (§103 recâblage : ne pas laisser une URL routée sur un chemin non intentionnel).
            La page Settings héberge Payments + Earnicoins balance — équivalent fonctionnel
            « portefeuille » pour l'utilisateur connecté. Redirect explicite = 0 doublon de route. */}
        <Redirect exact from={EPATHS.WALLET} to={EPATHS.SETTINGS} />
        {/* <Route exact path={EPATHS.MAPS} component={Maps} /> */}
        <Route exact path={EPATHS.MAP} component={Map} />
        {/* <Route exact path={EPATHS.RESET_PASSWORD} component={ResetPassword} /> */}
        <Route exact path={EPATHS.CHANGE_EMAIL} component={ChangeEmail} />
        <Route exact path={EPATHS.CONFIRM_PASSWORD} component={ConfirmPassword} />
        {/* /tile-map redirige vers le nouveau système canvas V2 (TileMapV2, #142).
            L'ancien composant TileMap reste en code mais n'est plus routé. */}
        <Route exact path={EPATHS.TILE_MAP} component={TileMapV2} />
        <Route exact path={EPATHS.TILE_MAP_V2}><Redirect to={EPATHS.TILE_MAP} /></Route>
        {/* /getstarted → landing fusionnée (Home + Get Started) : alias HomePage.
            Ancien GetStarted conservé en import (non routé) pour rollback éventuel. */}
        <Route exact path={EPATHS.GET_STARTED} component={HomePage} />
        <Route exact path={EPATHS.CART} component={CartPage} />
        <Route exact path={EPATHS.USDC_AVAX} component={CryptoExchange} />
        <Route exact path={EPATHS.BUY_FROM_EPIC} component={BuyFromEpic} />
        <ProtectedRoute exact path={EPATHS.EPIC_SSO} component={EpicSSO} allowed={isAuthenticated} />
        {/* /myProfile (ancien MyProfile.jsx) supprimé : profil unifié sur /profile/:id (PublicProfile).
            On garde une redirection back-compat pour les anciens liens : /myProfile -> /profile/<userId>
            (ou /home si user pas authentifié). signedUserId lu depuis localStorage._user (même source
            que `isAuthenticated`/`signedUser` au-dessus, source unique = le store). */}
        {(() => {
          const userId = isAuthenticated ? signedUser.id : null;
          return <Route exact path={EPATHS.MY_PROFILE} render={() => <Redirect to={userId ? `/profile/${userId}` : EPATHS.HOME} />} />;
        })()}
        {/* /editProfile (ancien Profile/index.jsx legacy MUI) → redirige vers /profile/<id>?edit=1
            (mode édition inline DA, cf. tasks/edit-profile-da-tracking.md). */}
        {(() => {
          const userId = isAuthenticated ? signedUser.id : null;
          return <Route exact path={EPATHS.EDIT_PROFILE} render={() => <Redirect to={userId ? `/profile/${userId}?edit=1` : EPATHS.HOME} />} />;
        })()}
        {/* Coupon + AdminAction : contenu déplacé dans Settings — rediriger vers /setting */}
        <Route exact path={EPATHS.COUPON} render={() => <Redirect to={EPATHS.SETTINGS} />} />
        <Route exact path={EPATHS.COUPON_DETAIL} render={() => <Redirect to={EPATHS.SETTINGS} />} />
        <ProtectedRoute exact path={EPATHS.CREATE_OPTIONS} component={CreateOption} allowed={isAuthenticated && isAdmin} />
        <ProtectedRoute exact path={EPATHS.CREATE_MULTIPLE} component={CreateMultiple} allowed={isAuthenticated && isAdmin} />
        {/* <ProtectedRoute exact path={EPATHS.PROFILE_MANAGEMENT} component={UsersList} allowed={isAuthenticated} /> */}
        {/* <ProtectedRoute exact path={EPATHS.CREATE_PROFILE} component={CreateUser} allowed={isAuthenticated} /> */}
        <ProtectedRoute exact path={EPATHS.MY_NFTS} component={MyNFTs} allowed={isAuthenticated} />
        <Redirect exact from={EPATHS.MY_NFTS_LEGACY} to={EPATHS.MY_NFTS} />
        <Redirect exact from={EPATHS.MY_NFTS_LEGACY2} to={EPATHS.MY_NFTS} />
        <ProtectedRoute exact path={EPATHS.MY_COLLECTIONS} component={Collections} allowed={isAuthenticated && isCreator} />
        <ProtectedRoute exact path={EPATHS.MY_BIDS} component={MyBids} allowed={isAuthenticated} />
        <ProtectedRoute exact path={EPATHS.EDIT_ITEM} component={EditItem} allowed={isAuthenticated} />
        <ProtectedRoute exact path={EPATHS.MY_COLLECTION_HISTORY} component={CollectionHistory} allowed={isAuthenticated && isCreator} />
        <ProtectedRoute exact path={EPATHS.MY_COLLECTION_DETAIL} component={CollectionDetail} allowed={isAuthenticated && isCreator} />
        <ProtectedRoute exact path={EPATHS.NOTIFICATIONS} component={Notifications} allowed={isAuthenticated} />
        <ProtectedRoute exact path={EPATHS.TRANSACTIONS} component={Transactions} allowed={isAuthenticated} />
        <ProtectedRoute exact path={EPATHS.GAIN} component={Gain} allowed={isAuthenticated && (isSnapshot || isAdmin)} />
        <ProtectedRoute exact path={EPATHS.SETTINGS} component={Settings} allowed={isAuthenticated} />
        {/* AdminAction : contenu déplacé dans Settings (section inline) — rediriger */}
        <Route exact path={EPATHS.ADMIN_ACTION} render={() => <Redirect to={EPATHS.SETTINGS} />} />
        {/* Routes support — factorisées dans le tableau partagé supportRoutes (§9 DRY), consommé
            aussi par le Switch support-only (isSupportHost). Mêmes routes, même ordre. */}
        {supportRoutes}
        <ProtectedRoute exact path={EPATHS.MARKET_STATS} component={MarketStats} allowed={isAuthenticated && isAdmin} />
        <ProtectedRoute exact path={EPATHS.ANALYTICS_DASHBOARD} component={AdminAnalytics} allowed={isAuthenticated && isAdmin} />
        {/* Catch-all 404 : toute URL inconnue → redirige vers Home (évite l'écran blanc). Doit rester en DERNIER. */}
        {/* API Docs — admin ou collaborateur */}
        <ProtectedRoute exact path={EPATHS.API_DOCS} component={ApiDocs} allowed={isAuthenticated && isCollaboratorUE} />
        {/* FT-006 Portfolio */}
        <ProtectedRoute exact path={EPATHS.PORTFOLIO} component={PortfolioPage} allowed={isAuthenticated} />
        {/* FT-003 Watchlist */}
        <ProtectedRoute exact path={EPATHS.WATCHLIST} component={WatchlistPage} allowed={isAuthenticated} />
        {/* FT-056 Author Collections (public) */}
        <Route exact path={EPATHS.AUTHOR_COLLECTION_DETAIL} component={AuthorCollectionDetail} />
        <Route exact path={EPATHS.AUTHOR_COLLECTIONS} component={AuthorCollectionsPage} />
        {/* Subscription mensuel (SPEC-2026-06-14) */}
        <ProtectedRoute exact path={EPATHS.SUBSCRIPTION} component={UserSubscriptionPage} allowed={isAuthenticated} />
        {/* Earnicoins packs purchase page — PUBLIQUE (accessible délogué) ; chaque action
            (Add to cart / Subscribe / Claim) force la connexion via EarniWalletModal in-page. */}
        <Route exact path={EPATHS.EARNICOINS_PACKS} component={EarnicoinsPacksPage} />
        <Redirect to={EPATHS.HOME} />
      </Switch>
      )}
      </Suspense>
    </Router>
    </div>
      <ModalRegister
      open={showRegisterModal}
      onClose={()=> setShowRegisterModal(false) }
      showResend={async () => {
        await AuthService.resend({metamask: signedUser.metamask});
        setShowResendModal(true);
        setShowRegisterModal(false)
        }
      }
    />
    <CodeVerification
      open={showResendModal}
      onClose={() => setShowResendModal(false)}
      formData={formData}
      isRegister={signedUser.isConnectingWallet ? true : false}
    />
    </div>
    </LoadingProvider>
  );
}

export default Main;
